import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const pages = {
  '/': ['BAi Systems | Technology that disappears into architecture.', 'Building automation design, documentation and commissioning for architecturally sophisticated buildings.'],
  '/wellwired': ['Wellwired by BAi — All the intelligence. None of the noise.', 'The healthy-home design practice of BAi Systems. Controls and connections that make home systems work together, coordinated with your architect and trades.'],
  '/wellwired-a': ['Wellwired by BAi — Indoor air quality. Hardwired by design.', 'Healthy-home technology design for new construction: indoor air quality, low-RF connectivity, lighting controls and water systems, coordinated with your architect and trades.'],
  '/wellwired-b': ['Wellwired by BAi — Low-RF technology. Air quality built in.', 'Hardwired technology design for new homes: air monitoring, low-RF connectivity, leak detection and automatic water shutoff, coordinated with your project team.'],
  '/wellwired-review': ['Wellwired — Compare the new designs', 'Review the original Wellwired page and two research-led openings for its redesigned website.'],
  '/builders': ['For Builders | BAi Systems', 'Clear scopes, coordinated trades and complete system documentation. Building automation planned around your construction schedule.'],
  '/architects': ['For Architects & Designers | BAi Systems', 'Building systems that respect your design intent, with architecture-ready drawings and early trade coordination.'],
  '/homeowners': ['For Homeowners | BAi Systems', 'Considered building automation, designed around daily life. Explore design, engineering and support for your home with BAi Systems.'],
  '/partners': ['Installation Partners | BAi Systems', 'System design and documentation for skilled field partners. Clear roles from drawings through commissioning and support.'],
  '/consulting': ['Consulting & Advisory | BAi Systems', 'Independent building-technology consulting from concept: infrastructure, scope, budgets and coordination.'],
  '/about': ['About BAi Systems', 'Commercial-grade discipline for building automation: design, documentation, trade coordination and commissioning.'],
  '/contact': ['Contact BAi Systems', 'Discuss a building project, design consultation or installation partnership with BAi Systems.'],
  '/partner-program': ['Field Partner Waitlist | BAi Systems', 'Register your interest in field installation opportunities with BAi Systems.'],
  '/mastermind': ['Mastermind | BAi Systems', 'Connect with the BAi Systems Mastermind.'],
};

export default function PageMetadata() {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.replace(/\/+$/, '') || '/';
    const [title, description] = pages[path] || pages['/'];
    const preview = ['/wellwired-a', '/wellwired-b', '/wellwired-review'].includes(path);
    document.title = title;
    for (const [selector, content] of [
      ['meta[name="description"]', description],
      ['meta[property="og:title"]', title],
      ['meta[property="og:description"]', description],
      ['meta[property="og:url"]', `https://bai-systems.com${path}`],
    ]) {
      const element = document.querySelector(selector);
      if (element) element.setAttribute('content', content);
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) canonical.setAttribute('href', `https://bai-systems.com${preview ? '/wellwired' : path}`);
    // Review drafts are intentionally separate from the public page. Restore
    // the prior robots state when navigating back to an ordinary site route.
    if (preview) {
      const existing = document.querySelector('meta[name="robots"]');
      const robots = existing || document.createElement('meta');
      const previous = existing?.getAttribute('content');
      robots.setAttribute('name', 'robots');
      robots.setAttribute('content', 'noindex, nofollow');
      if (!existing) document.head.appendChild(robots);
      return () => {
        if (existing) robots.setAttribute('content', previous || '');
        else robots.remove();
      };
    }
  }, [pathname]);
  return null;
}
